module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("First Mariner Books edition 2011")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Copyright © 1964 by Philip K. Dick")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright renewed 1992 by Laura Coelho, Christopher Dick, and Isa Hackett")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('a', {
    attrs: {
      "id": "px0"
    }
  }), _vm._v("Originally published by Belmont Books in 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Dick, Philip K.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("The penultimate truth / Philip K. Dick.—1st Mariner Books ed.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("ISBN 978-0-547-57247-5")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("1. Nuclear warfare—Fiction. 2. Underground areas—Fiction. 3. Regression (Civilization)—Fiction. I. Title. ")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("PS3554.I3P4 2011")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("813'.54—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("2011015942")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("eISBN 978-0-547-60135-9"), _c('br'), _vm._v("\nv2.0620")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0